import { SettingsPage } from '@/admin-design/_common/settings'
import { useVersion } from '@/lib/queries'
import { cn } from '@/lib/utils'
import { PageHeader } from '@/ui'
import StatsApiPanel from './StatsApiPanel'

const customRegistry = { 'stats-api-token': StatsApiPanel }

/** A binary built without the version ldflags (`go run`, a local build)
 *  reports version "dev". */
export const isDevBuild = (v: { version?: string } | undefined) => !!v && (!v.version || v.version === 'dev')

/** /settings: the server's own settings panels (what the manifest declares:
 *  Stats API, 정보) under the console's header. The panels are _common's and
 *  keep their own tabs; `?tab=<group key>` opens one. The Stats API panel is
 *  ours, registered under the manifest's custom component key.
 *
 *  _common prints its own English "Settings" title and the version badge
 *  first; the title is hidden so the page has one heading (설정). The badge
 *  stays for a release build ("v1.4.0 · abc1234 · 2026-10-21"); a dev build
 *  would read "vdev · dev · unknown", so its _common header goes and the
 *  page says 개발 빌드 instead. */
export default function Settings() {
  const v = useVersion()
  const dev = isDevBuild(v.data)
  return (
    <>
      <PageHeader title="설정" description={dev ? '개발 빌드' : undefined} />
      <div className={cn('[&_h1]:hidden [&>div]:!max-w-none [&>div]:!p-0', dev && '[&>div>header]:hidden')}>
        <SettingsPage customRegistry={customRegistry} />
      </div>
    </>
  )
}
